/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/openQuotePopup.ts
 * FILE_ID: JOBHUB-QA-QUOTE-POPUP-001
 * PURPOSE: Open the existing quote-builder route in a resizable window.
 */
export function quotePopupPath(quote: { quotebuilder_id?: number | null; job_id?: number | null; quote_number: string }, jobId: number) {
  if (quote.quotebuilder_id) return `/quote-builder/${quote.quotebuilder_id}`
  return `/jobs/${quote.job_id ?? jobId}/quote/${encodeURIComponent(quote.quote_number)}`
}

export async function viewQuoteUrl(
  quote: { quotebuilder_id?: number | null; job_id?: number | null; quote_number: string },
  jobId: number,
): Promise<string | null> {
  const path = quotePopupPath(quote, jobId)
  const company = window.location.pathname.match(/^(\/company\/[^/]+)/)
  if (company) return `${window.location.origin}${company[1]}${path}`
  if (!window.location.hostname.startsWith('qa.')) return null
  try {
    const { getConfiguredClient } = await import('@quotech/api')
    const { data } = await getConfiguredClient().get('/v2/company-dashboards/')
    const slug = data?.default_company_slug || data?.dashboards?.[0]?.slug
    return slug ? `https://dashboard.quotech.ai/company/${slug}${path}` : null
  } catch {
    return null
  }
}

export function openQuotePopup(url: string): string | null {
  const opened = window.open(url, 'qa-quote', 'popup=yes,width=1200,height=800,resizable=yes')
  if (!opened) return 'Allow popups to view this quote.'
  return null
}
